<template lang="pug">
  div
    page_header(:title="'Stall - '+this.startup", subhead="Analytics")
      button.btn.btn-primary(@click="openModal" v-if="user.user.permissions.includes('admin:stall:export')" ) Export to Google Sheet
    .row
      .col-sm-12
        .row.justify-content-center
          .col-sm-2
            .card.bg-red(:class="sending?'loading':''")
              .card-body.p-2.text-center.text-white
                .h1.m-0.mt-3 {{this.visitors}}
                .mb-4 Visitors
          .col-sm-2
            .card.bg-orange(:class="sending?'loading':''")
              .card-body.p-2.text-center.text-white
                .h1.m-0.mt-3 {{this.analytics.live}}
                .mb-4 Live Interactions
          .col-sm-2
            .card.bg-lime(:class="sending?'loading':''")
              .card-body.p-2.text-center.text-white
                .h1.m-0.mt-3 {{this.analytics.business}}
                .mb-4 Business Cards
          .col-sm-2
            .card.bg-teal(:class="sending?'loading':''")
              .card-body.p-2.text-center.text-white
                .h1.m-0.mt-3 {{this.analytics.brochure}}
                .mb-4 Brochure Downloads

      .col-sm-12
        .card(:class="sending?'loading':''")
          .card-body.border-bottom.py-3
            .d-flex
              per_page.text-muted(v-model="form.perPage" @input="form.page=1;load_data()")
              //- table_filter.ml-auto.text-muted(v-model="form.searchParam" :items="['name', 'stage', 'subsector', 'sector', 'model', 'status']" @input="load_data()")
              //- search.ml-3.text-muted(v-model="form.query" @search="form.page=1;load_data()")

          .table-responsive
            table.table.card-table.table-vcenter.text-nowrap.datatable
              thead
                tr
                  th Name
                  th Email
                  th Phone
                  th Organisation
                  th Type
                  th.text-center Live Interaction
                  th.text-center Business Cards
                  th.text-center Brochure Download

              tbody
                tr(v-for="item in report.data")
                  td {{item.name}}
                  td {{item.email}}
                  td {{item.phone}}
                  td {{item.organisation}}
                  td {{item.type}}
                  td.text-center {{item.live}}
                  td.text-center {{item.business}}
                  td.text-center {{item.brochure}}


          pagination.card-footer.d-flex.align-items-center(:data="report", :page="form.page" @change="change_page")
  
      #confirm.modal.modal-blur.fade(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true')
        .modal-dialog.modal-sm.modal-dialog-centered(role='document')
          .modal-content
            button.close(type='button' data-dismiss='modal' aria-label='Close')
              i.feather-x
            .modal-body.py-5
              form_input(type="text" name="sheet_url" label="Google Sheet Url" placeholder="Google Sheet Url" v-model="sheet_url" )  
              
              p Before proceeding Share sheet with
              p.m-0 
                b cross-sell@cross-sell-280112.iam.gserviceaccount.com

            .modal-footer
              button.btn.btn-red.btn-block(:disabled='sending' @click="exportdb")
                .spinner-border.spinner-border-sm.mr-2(v-if='sending')
                | Proceed
              a.btn.btn-secondary.btn-block(href='#' data-dismiss='modal')
                | Cancel

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import pagination from '@/components/pagination'
import perPage from '@/components/perPage'
import search from '@/components/search'
import filter from '@/components/filter'
import form_input from '@/components/formInput'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Stall',
  props: ['id'],
  data(){
    return {
      report: [],
      startup: '',
      analytics: [],
      visitors: 0,
      sheet_url: '',
      form: {
        perPage : 10,
        searchParam: 'name',
        query: '',
        page:1,
        eventday: this.id
      },
      interval: 30000,
      t: null,
    }
  },
  components: {
    page_header: page_header,
    pagination,
    per_page: perPage,
    form_input,
    search,
    table_filter: filter,
  },
  computed: {
    ...mapState('api', ['sending']),
    ...mapState('auth', ['user'])
  },
  methods:{
    load_data(){
      var vm = this;
      this.call({ _vm: this, endpoint:'admin/stall/'+this.id+'/visitors', method: 'GET', params: this.form })
        .then((response)=>{
          vm.report = response.data;
          vm.startup = response.startup;
          // vm.form.searchParam = response.searchParam;
          // vm.form.query = response.query;
          // vm.form.perPage = response.perPage;
          // vm.form.page = response.data.current_page;
        });
    },
    change_page(page){
      this.form.page = page;
      this.load_data();
    },
    load_analytics(){
      var vm = this;
      this.call({ _vm: this, endpoint:'admin/stall/'+this.id+'/analytics', method: 'GET' }).then(function(response){
        if(JSON.stringify(vm.analytics) == JSON.stringify(response.data)){
          vm.interval *= 2;
          if(vm.interval>240000){
            vm.interval = 30000;
          }
        }
        else{
          vm.analytics = response.data;
          vm.visitors = response.count;
          vm.interval = 30000;
        }
      });
    },
    openModal(){
      $('#confirm').modal('show')
    },
    exportdb(){
      this.call({ _vm: this, endpoint:'admin/stall/'+this.id+"/export", method: 'POST', data:{sheet_url: this.sheet_url} })
        .then(function(){
          $('#confirm').modal('hide')
        });
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    this.load_data();
    this.load_analytics();
    this.t = setInterval(function () {
      this.load_analytics();
    }.bind(this), this.interval); 
  },
  beforeDestroy(){
    clearInterval(this.t)
  }
}
</script>
